import { useMutation } from "@tanstack/react-query";
import { apiFetch } from "@/shared/lib/bff/client";
import { logger } from "@/shared/lib/logger";

interface ReportUserParams {
  reportedUserId: string;
  reasons: string[];
  details?: string;
}

async function reportUser(params: ReportUserParams): Promise<void> {
  await apiFetch("/api/reports", {
    method: "POST",
    body: JSON.stringify(params),
  });

  logger.info("User reported", {
    targetUserId: params.reportedUserId,
    reasons: params.reasons.join(", "),
  });
}

export function useReportUser() {
  return useMutation({
    mutationFn: reportUser,
  });
}
